// extracted by mini-css-extract-plugin
export default {"App":"EledoPageLoader_App__k2G5M","Loader":"EledoPageLoader_Loader__Ooojb","LoaderImage":"EledoPageLoader_LoaderImage__-VJek"};